// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__efFoj","section":"Footer_section__lyKsT","link":"Footer_link__kwMaX","linkTitle":"Footer_linkTitle__BXXLK","linkContent":"Footer_linkContent__RGno8"};